export const selectAnalyticsState = (state) => state.analytics || {};

export const selectAnalyticsData = (state) => selectAnalyticsState(state).data;
export const selectAnalyticsTimeRange = (state) => selectAnalyticsState(state).timeRange;
export const selectAnalyticsFilters = (state) => selectAnalyticsState(state).filters;
export const selectAnalyticsIsLoading = (state) => selectAnalyticsState(state).isLoading; 